import { render, staticRenderFns } from "./shtcyzbzx.vue?vue&type=template&id=40b2c7c1"
import script from "./shtcyzbzx.vue?vue&type=script&lang=js"
export * from "./shtcyzbzx.vue?vue&type=script&lang=js"
import style0 from "./shtcyzbzx.vue?vue&type=style&index=0&id=40b2c7c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports